module.exports = __webpack_public_path__ + "static/media/Avatar_16.0afffd2a.svg";